// ----------------------------------------------------------------------
// <copyright file="Izenda.Izenda.RowDataObject.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//
// </copyright>
// ----------------------------------------------------------------------

/**
 * RowDataObject
 */
!(function() {
  const { isEmpty, forEach, map, isNil, get, last, concat, sumBy, compact, flatMap } = require('lodash/fp');

  var m = require('mobx');

  var RowDataObject = function(level, keyPath, isExpand, item) {
    var lastKey = last(item.key);
    this.key = lastKey.columnName;
    // field name alias when receive data, ensure unique, uneffected by rename fieldNameAlias
    this.uniqueFieldNameAlias = get('element.field.fieldNameAlias', lastKey);
    this.element = lastKey.element;
    this.value = lastKey.value;
    this.subKeyPath = concat(keyPath, { element: lastKey.element, value: this.value });
    this.dataForGroup = [];
    this.dataForSubTotal = [];
    this.childs = map(createRowDataObject.bind(null, level - 1, this.subKeyPath, isExpand), item.subGroup);
    isExpand = isExpand ||
      (get('element.properties.fieldItemVisible', lastKey) === false && keyPath.every(k => get('element.properties.fieldItemVisible', k) === false));
    this.data = isNil(item.subGroup) || !isExpand ? compact(item.data) : [];
    this.subTotalMapping = null;
    // descecding level, for knowing how many sub level left to the farthest leaf
    // using for add empty cell for missing level
    this.level = level;
    // ascendingLevel level, fow knowing how many level from the root
    // using for sending api request
    this.ascendingLevel = lastKey.level;

    m.extendObservable(this, {
      isExpand: isEmpty(this.childs) ? false : !!isExpand,
      isExpandable: function() {
        return this.level > 1;
      },
      size: function() {
        if (isEmpty(this.childs)) {
          return 1;
        }
        return sumBy('size', this.childs);
      },
      childsData: function() {
        if (isEmpty(this.childs)) {
          return this.data;
        }
        return flatMap('childsData', this.childs);
      }
    });
  };

  var createRowDataObject = function(level, keyPath, isExpand, item) {
    return new RowDataObject(level, keyPath, isExpand, item);
  };

  RowDataObject.prototype.nearestAscendingLevelToExpand = function () {
    if (this.childs.length <= 0 || this.childs.some(c => get('element.properties.fieldItemVisible', c) === true))
      return this.ascendingLevel;
    return Math.min(...this.childs.map(c => c.nearestAscendingLevelToExpand()));
  }

  RowDataObject.prototype.buildDrillDownParams = function (forExpand) {
    return {
      expandedLevel: forExpand ? this.nearestAscendingLevelToExpand() : this.ascendingLevel - 1,
      filters: map(function(item) {
        return {
          key: item.element.field.fieldNameAlias,
          value: item.value
        };
      }, this.subKeyPath)
    };
  };

  RowDataObject.prototype.setChilds = function(rowDataObjects) {
    forEach(
      function(item) {
        item.level = this.level - 1;
        item.ascendingLevel = this.level + 1;
        item.subKeyPath = concat(this.subKeyPath, item.subKeyPath);
      }.bind(this),
      rowDataObjects
    );
    this.childs = rowDataObjects;
  };

  RowDataObject.prototype.toggleExpand = function(value) {
    if (isNil(value)) {
      this.isExpand = !this.isExpand;
    } else {
      this.isExpand = value;
    }
  };

  module.exports = {
    RowDataObject: RowDataObject,
    createRowDataObject: createRowDataObject
  };
})();



// WEBPACK FOOTER //
// ./ui/logic/models/Izenda.RowDataObject.js